import Glide from '@glidejs/glide'

if ( $('.js-featured-posts-glide').length && window.matchMedia( '(max-width: 991px)' ).matches )
{
  new Glide('.js-featured-posts-glide', {
      type: 'carousel',
      gap: 15,
      autoplay: 5000,    
      perView: 3,
      oveflow: 'hidden',
      breakpoints: {
        767: {
          perView: 2,
        },
        991: {
            perView: 2,
          },
      },
  }).mount();
}